import { render } from "./CulturePoints.vue?vue&type=template&id=8f2961e6"
import script from "./CulturePoints.vue?vue&type=script&lang=js"
export * from "./CulturePoints.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/buildings/residence/CulturePoints.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8f2961e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8f2961e6', __exports__)) {
    api.reload('8f2961e6', __exports__)
  }
  
  module.hot.accept("./CulturePoints.vue?vue&type=template&id=8f2961e6", () => {
    api.rerender('8f2961e6', render)
  })

}


export default __exports__